<div>
	<ul>
		<li>user Agent - {{ deviceInfo.userAgent }}</li>

		<li>Os - {{ deviceInfo.os }}</li>

		<li>browser - {{ deviceInfo.browser }}</li>

		<li>device - {{ deviceInfo.device }}</li>

		<li>os_version - {{ deviceInfo.os_version }}</li>

		<li>browser_version - {{ deviceInfo.browser_version }}</li>

		<li>deviceType - {{ deviceInfo.deviceType }}</li>

		<li>orientation - {{ deviceInfo.orientation }}</li>

		<li>Model Name - {{ this.data }}</li>
	</ul>
</div>

<div>
	<h1>Is Mobile?</h1>

	<pre>{{ isMobile }}</pre>
</div>

<div>
	<h1>Is Tablet?</h1>

	<pre>{{ isTablet }}</pre>
</div>

<div>
	<h1>Is Desktop?</h1>

	<pre>{{ isDesktop }}</pre>
</div>

<!-- <div class="mdc-layout-grid__inner">
    
    <div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
          <nav mat-tab-nav-bar>
        <a mat-tab-link [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [queryParams]="{ lang: locale.lang }" > All ads  </a>
        <a  mat-tab-link [routerLink]="['/dealers']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }" [queryParams]="{ lang: locale.lang}" > Dealers </a>
      </nav>
    </div>
    </div> -->
